<div
    class="tw-bg-[#0A0A75] tw-text-white tw-flex tw-items-center md:tw-px-[30px] tw-gap-10 tw-relative tw-pt-8 md:tw-py-4 tw-pb-0 md:tw-h-[285px] xl:tw-h-[365px]"
>
    <div class="tw-max-w-[1280px] tw-w-full tw-mx-auto">
        <!-- Left Content -->
        <div
            class="tw-text-center tw-max-w-[320px] tw-translate-y-[60px] md:tw-translate-y-0 tw-mx-auto sm:tw-mx-0 sm:tw-text-left tw-relative tw-z-10 lg:tw-max-w-[500px]"
        >
            <p
                class="tw-w-full tw-text-[26px] xl:tw-text-[38px] tw-text-white tw-font-bold tw-leading-[100%] lg:tw-leading-[47px]"
            >
                {{ "DIGITAL_SERVICES.TITLE" | translate }}
            </p>
            <p
                class="!tw-text-[13px] md:!tw-text-[14px] tw-mb-6 tw-font-normal tw-leading-[141%] lg:tw-leading-[22px]"
            >
                {{ "DIGITAL_SERVICES.DESC" | translate }}
            </p>
        </div>

        <!-- Right Content -->
        <div
            class="tw-w-full tw-mt-[-100px] md:tw-hidden tw-flex tw-flex-col md:tw-h-full md:tw-justify-end"
        >
            <img
                src="/assets/images/digital-services/banner-mob.png"
                alt="Digital services"
                class="tw-w-full tw-h-auto tw-max-h-[455px] lg:tw-max-h-[500px]"
            />
        </div>
        <img
            src="/assets/images/digital-services/banner.png"
            alt="Digital services"
            class="tw-w-fit tw-absolute tw-top-0 tw-right-0 tw-h-auto tw-hidden xl:tw-block md:tw-self-end md:tw-h-full md:tw-object-contain md:tw-object-bottom"
        />
        <img
            src="/assets/images/digital-services/banner-tab.png"
            alt="Digital services"
            class="tw-w-fit tw-absolute tw-top-0 tw-right-0 tw-h-auto tw-hidden md:tw-block xl:tw-hidden md:tw-self-end md:tw-h-full md:tw-object-contain md:tw-object-bottom"
        />
    </div>
</div>
